export default "__VITE_ASSET__UiXUcgPxVrXjan1d0C9YbA__"